export default __webpack_public_path__ + "static/media/phone.3bfec738.svg";